import { useEffect } from 'react';
import { useMatch } from 'react-router-dom';
import { isProduction } from 'Douleutaras/constants/system';
import { getAbsoluteUrl } from 'Douleutaras/utilities/url-builder';
import { useSalesForceChat } from 'Douleutaras/providers/chat/hooks/useSalesForceChat';

import './chat/SalesForceChat.provider.scss';

export const WebChatProvider = () => {
  const salesForceChat = useSalesForceChat();

  const clientDashboardRoute = useMatch({
    path: getAbsoluteUrl('CLIENT_DASHBOARD.INDEX'),
    end: true
  });
  const isClientDashboard = clientDashboardRoute !== null;

  if (!isProduction) {
    // tslint:disable-next-line:no-null-keyword
    return null;
  }

  const checkChatStatus = () => isClientDashboard
    ? salesForceChat.show()
    : salesForceChat.hide();

  useEffect(() => {
    if (salesForceChat && isClientDashboard) {
      salesForceChat
        .load()
        .then(() => checkChatStatus());

      return () => salesForceChat.unmount();
    }
  }, [salesForceChat]);

  useEffect(() => {
    if (!salesForceChat) {
      return;
    }
    checkChatStatus();
  }, [isClientDashboard]);

  // tslint:disable-next-line:no-null-keyword
  return null;
};
